import React from "react";
import { Box, Modal } from "@mui/material";
import { AlertTriangle } from "lucide-react";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 0,
};

const DeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  brand,
  isLoading,
  isRestore = false,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <div className="p-6">
          <div className="flex flex-col items-center text-center">
            <div
              className={`w-12 h-12 rounded-full ${
                isRestore ? "bg-green-50" : "bg-red-50"
              } flex items-center justify-center mb-4`}>
              <AlertTriangle
                className={`w-6 h-6 ${
                  isRestore ? "text-green-500" : "text-red-500"
                }`}
              />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              {isRestore ? "Restore Brand" : "Delete Brand"}
            </h3>
            <p className="text-sm text-gray-500 mb-4">
              Are you sure you want to {isRestore ? "restore" : "delete"} the
              brand "{brand?.name}"?
            </p>

            {/* Impact Information */}
            <div
              className={`p-3 rounded-lg text-sm mb-4 ${
                isRestore
                  ? "bg-green-50 text-green-700"
                  : "bg-red-50 text-red-600"
              }`}>
              {isRestore ? (
                <>
                  <p className="font-medium mb-1">Impact of Restoration:</p>
                  <ul className="text-left space-y-1">
                    <li>• Brand will be available in the system again</li>
                    <li>• You can reactivate the brand when needed</li>
                    <li>• Associated products can be restored</li>
                  </ul>
                </>
              ) : (
                <>
                  <p className="font-medium mb-1">Impact of Deletion:</p>
                  <ul className="text-left space-y-1">
                    <li>• Brand will be moved to trash</li>
                    <li>• All associated products will be hidden</li>
                    <li>• You can restore the brand later if needed</li>
                    {brand?.metadata?.products_count > 0 && (
                      <li className="font-medium mt-2">
                        ⚠️ This brand has {brand.metadata.products_count} active
                        products that will be affected
                      </li>
                    )}
                  </ul>
                </>
              )}
            </div>

            <div className="flex gap-3">
              <button
                onClick={onClose}
                disabled={isLoading}
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50">
                Cancel
              </button>
              <button
                onClick={onConfirm}
                disabled={isLoading}
                className={`px-4 py-2 text-white rounded-lg text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 ${
                  isRestore
                    ? "bg-green-600 hover:bg-green-700"
                    : "bg-red-600 hover:bg-red-700"
                }`}>
                {isLoading ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    {isRestore ? "Restoring..." : "Deleting..."}
                  </>
                ) : isRestore ? (
                  "Restore Brand"
                ) : (
                  "Delete Brand"
                )}
              </button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmationModal;
